module.exports = __webpack_public_path__ + "img/logout.1b7a1a8f.svg";